import { z } from "zod";
import type {
    FeeSourceNotificationsEmail} from "./notifications/email/fee-source-notifications-email";
import {
    feeSourceNotificationsEmailZodSchema,
} from "./notifications/email/fee-source-notifications-email";
import type {
    FeeSourceNotificationsSms} from "./notifications/sms/fee-source-notifications-sms";
import {
    feeSourceNotificationsSmsZodSchema,
} from "./notifications/sms/fee-source-notifications-sms";
import type {
    FeeSourceOrders} from "./orders/fee-source-orders";
import {
    feeSourceOrdersZodSchema,
} from "./orders/fee-source-orders";
import type {
    FeeSourceTransactions} from "./transactions/fee-source-transactions";
import {
    feeSourceTransactionZodSchema,
} from "./transactions/fee-source-transactions";

/**
 * A fee source is info on what data is used to calculate a fee.
 * E.g. fees for orders with a special delivery type, or orders bought on a specific destination etc.
 */
type FeeSource =
    | FeeSourceOrders
    | FeeSourceNotificationsEmail
    | FeeSourceNotificationsSms
    | FeeSourceTransactions;
const feeSourceZodSchema = z.union([
    feeSourceOrdersZodSchema,
    feeSourceNotificationsEmailZodSchema,
    feeSourceNotificationsSmsZodSchema,
    feeSourceTransactionZodSchema,
]);

export { feeSourceZodSchema };
export type { FeeSource };
